import { LoadingSpinner } from './loading-spinner.tsx'

export const LoadingOverlay = () => (
  <div className="fixed h-screen w-screen inset-0 flex items-center justify-center z-999">
    <LoadingSpinner className="text-brand h-20 w-20" />
  </div>
)
